// extracted by mini-css-extract-plugin
module.exports = {"confirmation":"style_confirmation__1Leo1","confirmationText":"style_confirmationText__16aOy"};